import { Store } from '@ngxs/store';
import { Observable, combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';
import { Injector, Type } from '@angular/core';
import { IFilterType, IMenuFilter } from '@nimbus-library/features/menu';
import { MenuFilterFactory } from '@nimbus-library/features/menu/services/factories/menu-filter.factory';
import { IAuthenticationService } from '@nimbus-library/features/authentication/services/i-authentication.service';
import { IPermissionManagerService } from '@nimbus-library/features/user-settings/services/contracts/i-permission-manager.service';

export interface CombineFilterParameter {
  filters: (Type<IMenuFilter<any>> | IFilterType<any>)[];
  condition: 'and' | 'or';
}

export class CombineFilter implements IMenuFilter<CombineFilterParameter> {
  public constructor(
    private readonly store: Store,
    private readonly authenticationService: IAuthenticationService,
    private readonly permissionManagerService: IPermissionManagerService,
    private readonly injector: Injector,
  ) {
    this.filterFactory = new MenuFilterFactory();
  }

  private readonly filterFactory: MenuFilterFactory;
  public static for(parameter: CombineFilterParameter) {
    return { type: CombineFilter, option: parameter };
  }

  public validate$(parameter: CombineFilterParameter): Observable<boolean> {
    const filters = parameter.filters.map((p) => this.filterFactory.createFilter$(p, this.injector));
    return combineLatest(filters).pipe(
      map((results) => (parameter.condition === 'or' ? results.some((r) => !!r) : results.every((r) => !!r))),
    );
  }
}
